module.exports = __webpack_public_path__ + "img/ic_right_arrow_b.60293670.svg";